import { render } from "./KPIDashboard.vue?vue&type=template&id=7b28e106&scoped=true&ts=true"
import script from "./KPIDashboard.vue?vue&type=script&lang=ts"
export * from "./KPIDashboard.vue?vue&type=script&lang=ts"

import "./KPIDashboard.vue?vue&type=style&index=0&id=7b28e106&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b28e106"]])

export default __exports__